import type { IServiceEmployee } from "@/services/types";
import { formatEmployeeName } from "@/hooks/data/dataQuality";
import styles from "./EmployeeSettingsCard.module.css";

export interface EmployeeSettingsCardProps {
  employee: IServiceEmployee;
  isBookable: boolean;
  isUpdating?: boolean;
  onOpenSettings?: () => void;
  className?: string;
  "data-testid"?: string;
}

export const EmployeeSettingsCard: React.FC<EmployeeSettingsCardProps> = ({
  employee,
  isBookable,
  isUpdating = false,
  onOpenSettings,
  className,
  "data-testid": testId,
}) => {
  const displayName = formatEmployeeName(employee);

  const open = () => {
    if (!isUpdating) onOpenSettings?.();
  };

  return (
    <article
      className={className ? `${styles.card} ${className}` : styles.card}
      data-testid={testId}
      data-bookable={isBookable ? "true" : undefined}
      data-updating={isUpdating ? "true" : undefined}
      role={onOpenSettings ? "button" : undefined}
      tabIndex={onOpenSettings ? 0 : undefined}
      onClick={onOpenSettings ? open : undefined}
      onKeyDown={
        onOpenSettings
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                open();
              }
            }
          : undefined
      }
      aria-label={
        onOpenSettings ? `Åpne innstillinger for ${displayName}` : undefined
      }
    >
      <div data-section="primary">
        <div className={styles.primaryHeading}>
          <h3 data-field="name">{displayName}</h3>

          <span
            className={styles.emailDisplay}
            data-testid={testId ? `${testId}-email` : undefined}
          >
            <span data-component="mail" className={styles.emailText}>
              {employee.email}
            </span>
          </span>
        </div>
      </div>

      <div data-section="secondary">
        <span data-field="department">
          {employee.department || "Ukjent avdeling"}
        </span>
      </div>
    </article>
  );
};

EmployeeSettingsCard.displayName = "EmployeeSettingsCard";
export default EmployeeSettingsCard;
